var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Bind"}},[_c('div',{staticClass:"g-right-top width800"},[_vm._v("个人中心／绑定账号")]),_vm._v(" "),_c('div',{staticClass:"g-right-middle margintop20 width800"},[_vm._v("\n        该功能正在开发中   ING......       \n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0314dff8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/group_admin/G_Bind.vue
// module id = null
// module chunks = 